import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  wordCount: {
    fontWeight: 'bold',
    marginLeft: theme.spacing(1),
  },
}));
